<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>保司公司管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 卡片 -->
    <el-card class="box-card" style="margin-top:20px">
      <!-- 搜索  新增-->
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form
              :inline="true"
              :model="searchForm"
              :rules="searchRules"
              ref="searchForRef"
              label-width="80px"
              autocomplete="on">
            <el-form-item label="保司名称" prop="name" size="small">
              <el-input v-model="searchForm.name" prefix-icon="el-icon-search" clearable type="text"></el-input>
            </el-form-item>
          </el-form>
        </el-col>
          <el-col :span="1">
            <el-button type="success" size="small" @click="searchSubmit()">搜索</el-button>
          </el-col>
          <el-col :span="3" :offset="1">
            <el-button type="primary" size="small" @click="addData">新增</el-button>
          </el-col>
        </el-row>
        <!-- 表格 -->
        <el-table
            ref="multipleTable"
            :data="tableLoadData"
            height="450"
            border
            >
          <el-table-column
            label="ID"
            width="50"
            prop="id"
           >
          </el-table-column>
          <el-table-column
            prop="name"
            label="保司名称"
            width="105"
            >
          </el-table-column>
          <el-table-column
            prop="credit_code"
            label="信用代码"
            width="105"
            >
          </el-table-column>
          <el-table-column
            prop="full_name"
            label="保司全称"
            width="105"
            >
          </el-table-column>
          <el-table-column
            prop="public_name"
            label="公户名称"
            width="105"
            >
          </el-table-column>
          <el-table-column
            prop="public_account"
            label="公户账号"
            width="105"
            >
          </el-table-column>
          <el-table-column
            prop="public_bank"
            label="所属银行"
            width="105"
            >
          </el-table-column>
          <el-table-column
            prop="public_open_bank"
            label="开户行"
            width="105"
            >
          </el-table-column>
          <el-table-column
            label="发票"
            width="105"
            >
            <template slot-scope="scope">
              <!--
              <span v-if="scope.row.invoice_status == 1"><el-button type="success" size="mini">{{scope.row.invoice_status | invoiceFilter}}</el-button></span>
              <span v-else><el-button type="danger" size="mini">{{scope.row.invoice_status | invoiceFilter}}</el-button></span>
              -->
              <span v-if="scope.row.invoice_status == 1"><p style="color:green">{{scope.row.invoice_status | invoiceFilter}}</p></span>
              <span v-else><p style="color:red">{{scope.row.invoice_status | invoiceFilter}}</p></span>
            </template>
          </el-table-column>
          <el-table-column
            prop="tel"
            label="报案电话"
            width="105"
            >
          </el-table-column>
          <el-table-column
            prop="sort"
            label="排序"
            width="105"
            >
          </el-table-column>
          <el-table-column
            label="添加时间"
            width="160"
            >
            <template slot-scope="scope">
              <span>{{ scope.row.add_time | dateFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            width="105"
            >
          </el-table-column>
          <el-table-column
              label="操作"

              width="130px"
              >
              <template slot-scope="scope">
                <el-button type="warning" icon="el-icon-edit" size="mini" @click="handelEdit(scope.row)"></el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" @click="handelDel(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="block" style="margin-top:10px">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNum"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
          </el-pagination>
        </div>
    </el-card>
    <!-- 新增编辑弹框 -->
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="550px">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">

        <el-form-item label="保司名称" prop="name" size="small">
          <el-input v-model="form.name" autocomplete="off" placeholder="请输入保司名称"></el-input>
        </el-form-item>
        <el-form-item label="公司/公户名称全称" prop="full_name" size="small">
          <el-input v-model="form.full_name" autocomplete="off" placeholder="请输入公司名称全称"></el-input>
        </el-form-item>
        <el-form-item label="信用代码" prop="credit_code" size="small">
          <el-input v-model="form.credit_code" autocomplete="off" placeholder="请输入社会统一信用代码"></el-input>
        </el-form-item>
        <!--
        <el-form-item label="公户名称" prop="public_name" size="small">
          <el-input v-model="form.public_name" autocomplete="off" placeholder="请输入公户名称"></el-input>
        </el-form-item>-->
        <el-form-item label="公户账号" prop="public_account" size="small">
          <el-input v-model="form.public_account" autocomplete="off" placeholder="请输入公户账号"></el-input>
        </el-form-item>
        <el-form-item label="所属银行" prop="public_bank" size="small">
          <el-input v-model="form.public_bank" autocomplete="off" placeholder="请输入公户所属银行"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="public_open_bank" size="small">
          <el-input v-model="form.public_open_bank" autocomplete="off" placeholder="请输入开户行"></el-input>
        </el-form-item>
        <el-form-item label="发票" size="small">
          <el-radio-group v-model="invoice_status">
            <el-radio :label="1">支持发票</el-radio>
            <el-radio :label="2">不支持发票</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="报案电话" prop="tel" size="small">
          <el-input v-model="form.tel" autocomplete="off" placeholder="请输入报案电话"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort" size="small">
          <el-input v-model="form.sort" autocomplete="off" placeholder="请输入0-255之间"></el-input>
        </el-form-item>
        <el-form-item label="备注"  size="small">
          <el-input v-model="form.remark" type="textarea" autocomplete="off" placeholder="请输入备注"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="reset_dialogForm('form')">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import eTable from "../common/eTable.vue";
import moment from 'moment'     //日期时间转换

export default {
  name: "adminStaff",
  components: {
    eTable
  },
  props: {},
  data() {
    return {
      // 搜索
      searchForm: {
        name: "",
      },
      searchRules: {
        name: [
          { required: true, message: "请输入保司名称", trigger: "blur" }
        ],
      },
      // 数据
      tableLoadData: [],
      pageNum:1,// 当前页码
      pageSize:10,// 每页大小
      total:0,//总条目数

      id: '',

      rules: {
        name: [
          { required: true, message: '请输入保司名称', trigger: 'blur' },
          // {
          //   min: 3,
          //   max: 15,
          //   message: "长度在 3 到 15 个字符",
          //   trigger: "blur",
          // }
        ],
        full_name: [
          { required: true, message: '请输入公司名称全称', trigger: 'blur' },
        ],
        credit_code: [
          { required: true, message: '请输入社会统一信用代码', trigger: 'blur' },
        ],
        public_name: [
          { required: true, message: '请输入公户名称', trigger: 'blur' },
        ],
        public_account: [
          { required: true, message: '请输入公户账号', trigger: 'blur' },
        ],
        public_bank: [
          { required: true, message: '请输入公户所属银行', trigger: 'blur' },
        ],
        public_open_bank: [
          { required: true, message: '请输入开户行', trigger: 'blur' },
        ],
        tel: [
          { required: true, message: '请输入报案电话', trigger: 'blur' },
        ]
      },

      dialogFormVisible: false,
      title: '',
      form: {
        name: '',
        full_name: '',
        credit_code: '',
        public_name: '',
        public_account: '',
        public_bank: '',
        public_open_bank: '',
        tel: '',
        sort: ''
      },
      invoice_status: 2
    };
  },
  created() {
    this.DataList()
  },
  mounted() {

  },
    filters: {
    dateFormat(add_time) {
      if (add_time == undefined) {
        return "";
      }
      return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
    },
    invoiceFilter(status) {
      if (status == 1) {
        return "支持";
      } else if (status == 2) {
        return "不支持";
      }
    }

  },
  methods: {
    DataList(){
      const param = {
          queryParams: this.searchForm.name,
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          page: this.pageNum,
          pageSize: this.pageSize,
      }
      this.$axios.corpList(param).then(res=>{
        if(res.code == 200){
          this.tableLoadData = res.data.data
          //console.log(res.data.data);
          this.total = res.data.total
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error=>{
        //console.log(error);
      })
    },

    // 设置每页条数
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.DataList()
    },
    // 分页跳转
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },

    // 新增
    addData() {
      this.title = '新增'
      this.form = {
        name: '',
      }
      this.dialogFormVisible = true
    },
    handelEdit(index,row) {
      //console.log(index,222);
      this.id = index.id
      this.title = '编辑'
      this.form = {
      }
      this.dialogFormVisible = true
      // this.form = {...row};
      // 或者
      this.form = JSON.parse(JSON.stringify(index))
    },

    reset_dialogForm(formName) {
      this.dialogFormVisible = false
      this.$nextTick(() => {
        this.$refs[formName].resetFields()
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.id){
            const param = {
              name: this.form.name,
              full_name: this.form.full_name,
              credit_code: this.form.credit_code,
              public_name: this.form.public_name,
              public_account: this.form.public_account,
              public_bank: this.form.public_bank,
              invoice_status: this.invoice_status,
              public_open_bank: this.form.public_open_bank,
              tel: this.form.tel,
              sort: this.form.sort,
              remark: this.form.remark,
              operator_id: sessionStorage.getItem('user_id'),
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token'),
            }
            //console.log(param,22);
            this.$axios.insuranceCorpSave(param).then(res =>{
                //console.log(res,7777);
                if(res.code == 200){
                  this.DataList()
                  this.$message.success(res.msg)
                  this.dialogFormVisible = false
                }else{
                    this.$message.error(res.msg);
                }
              })
            }else{
            const param = {
              id: this.form.id,
              name: this.form.name,
              full_name: this.form.full_name,
              credit_code: this.form.credit_code,
              public_name: this.form.public_name,
              public_account: this.form.public_account,
              public_bank: this.form.public_bank,
              invoice_status: this.invoice_status,
              public_open_bank: this.form.public_open_bank,
              tel: this.form.tel,
              sort: this.form.sort,
              remark: this.form.remark,
              operator_id: sessionStorage.getItem('user_id'),
              company_id:sessionStorage.getItem('company_id'),
              access_token:sessionStorage.getItem('token'),
            }
            this.$axios.insuranceCorpSave(param).then(res =>{
              if(res.code == 200){
                this.$message.success(res.msg)
                this.DataList()
                this.dialogFormVisible = false
              }else{
                  this.$message.error(res.msg);
              }
            })
          }

        }
      })
    },
    searchSubmit() {
      this.pageNum = 1,
      this.DataList()
    },

    handelDel(e) {
        //console.log(e);
        this.$confirm('此操作将删除该分类, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
        const param = {
          operator_id: sessionStorage.getItem('user_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          id: e.id,
        }
        this.$axios.insuranceCorpDel(param).then(res=>{
          if(res.code == 200){
            this.$message.success(res.msg);
            this.DataList()
          }else{
            this.$message.error(res.msg);
          }
        }).catch(error=>{
          //console.log(error);
        })
      }).catch(() => {
          // 点击取消:不删除了
          this.$message({
              type: 'info',
              message: '已取消删除'
          });
          this.DataList()
      });
      this.teamDialog = false
    },


  },
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/view/insurance/corpNameList.vue